"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const getWidth = (column, counts, defaultColumnWidth) => {
    if (column.props.hidden && !column.props.width) {
        return defaultColumnWidth;
    }
    if (!column.props.width) {
        const computedWidth = parseFloat((counts.availWidth / counts.undefinedWidthColumns).toFixed(2));
        return computedWidth > defaultColumnWidth ? computedWidth : defaultColumnWidth;
    }
    return column.props.width;
};
const computeColumnsWidth = ({ columns, layoutWidth = 0, scrollbarWidth, hasVerticalScroll, defaultColumnWidth }) => {
    const widthStore = {};
    const counts = {
        undefinedWidthColumns: 0,
        availWidth: hasVerticalScroll ? layoutWidth - scrollbarWidth : layoutWidth
    };
    react_1.default.Children.forEach(columns, (column) => {
        if (typeof column.props.width === 'number' && column.props.width && !column.props.hidden) {
            Object.assign(counts, {
                availWidth: counts.availWidth - column.props.width
            });
        }
        if (!column.props.width && !column.props.hidden) {
            Object.assign(counts, {
                undefinedWidthColumns: counts.undefinedWidthColumns + 1
            });
        }
    });
    react_1.default.Children.forEach(columns, (column) => {
        if (typeof column.key === 'string') {
            Object.assign(widthStore, {
                [column.key]: getWidth(column, counts, defaultColumnWidth)
            });
        }
    });
    return widthStore;
};
exports.default = computeColumnsWidth;
//# sourceMappingURL=computeColumnsWidth.js.map